// REGISTRATION

import { i18n } from "../app/pages/private/languageSelector";
import cloudIcon from "../assets/img/cloudImg.svg";
import devicesIcon from "../assets/img/devicesIcon.svg";
import noWifi from "../assets/img/noWifi.svg";
import analysis from "../assets/img/analysis.svg";
import fingerPoint from "../assets/img/fingerPointI.svg";
import reverseIcon from "../assets/img/reverseIcon.svg";
import personSpeak from "../assets/img/cloudImg.svg";
import callingIcon from "../assets/img/callingIcon.svg";
import Mall from "../assets/img/Mall.svg";
import industrial from "../assets/img/industrial.svg";
import Bussiness from "../assets/img/Bussiness.svg";
import electronics from "../assets/img/electronics.svg";
import clothes from "../assets/img/clothes.svg";
import Jewelery from "../assets/img/Jewelery.svg";
import cafe from "../assets/img/Cafe.svg";
import restaurant from "../assets/img/Restaurant.svg";
import Grocery from "../assets/img//Grocery.svg";
import tabletPos from "../assets/img/tablet-pos.png";
import tabletPosAr from "../assets/img/tablet-pos-img-ar.png";
import saleManagement from "../assets/img/management-sale-items.png";
import saleManagementAr from "../assets/img/sales-management-img-ar.png";
import branchManagement from "../assets/img/branch-management.png";
import branchManagementAr from "../assets/img/branch-management-ar.png";
import knowCustomers from "../assets/img/know-customers.png";
import knowCustomersAr from "../assets/img/know-customers-ar.png";
import reportAnalytics from "../assets/img/report-analytics.png";
import reportAnalyticsAr from "../assets/img/report-analytics-ar.png";
import moreFeatures from "../assets/img/more-features.png";
import moreFeaturesAr from "../assets/img/more-features-ar.png";
import tabletImage from "../assets/img/pos-product-display-homepage-img.png";
import tabletIcon from "../assets/img/tablet-icon.svg";
import noWifiIcon from "../assets/img/no-wifi-icon.svg";
import pinCodeIcon from "../assets/img/secure-pin-icon.svg";
import computerIcon from "../assets/img/computer-icon.svg";
import menuDisplayIcon from "../assets/img/menu-dropdown-icon-home.svg";
import createCategoryIcon from "../assets/img/category-icon.svg.png";
import productSettingsIcon from "../assets/img/product-setting-icon.svg";
import tickIcon from "../assets/img/tick-icon-blue.png";
import applyDiscountIcon from "../assets/img/discount-applying-icon.png";
import branchIcon from "../assets/img/branch-icon.svg";
import trackSalesIcon from "../assets/img/track-sales-icon.png";
import invoiceIcon from "../assets/img/invoice-icon.png";
import saleReportsIcon from "../assets/img/sale-reports-icon.svg";

import paymentIocn from "../assets/img/paymet-icons.svg";
import salesImg from "../assets/img/sales-pos-img.png";
import viewInvoiceImg from "../assets/img/invoice-preview-img.png";
import applyDiscountImg from "../assets/img/apply-discount-img.png";
import paymentsImg from "../assets/img/updated-payments-image-homepage.png";
import viewInvoicesImg from "../assets/img/view-invoices-img.png";
import productDisplayImg from "../assets/img/product-display-img.png";
import pinCodeDisplayImg from "../assets/img/pin-code-display-img.png";
import createCategoryImg from "../assets/img/create-category-img-homepage.png";
import applyDiscountsImg from "../assets/img/discount-applying-img.png";
import fullControlImg from "../assets/img/full-control-homepage-img.png";
import productSettingsImg from "../assets/img/products-setting-image-homepage.png";
import branchFirstImg from "../assets/img/customize-invoice-img.png";
// import branchSecondImg from "../assets/img/multiple-branch-img.png";
import branchSecondImg from "../assets/img/multiple-branch-image-homepage.png";
import trackSalesImg from "../assets/img/track-sales-img-homepage.png";
import salesReportsImg from "../assets/img/sales-reports-img-homepage.png";
import viewOfInvoicesImg from "../assets/img/view-of-invoices-image.png";

export const FATORATAY_AUTH = "FATORATY_AUTH";

export const ACCOUNT_TYPES = {
  INDIVIDUAL: "INDIVIDUAL",
  COMPANY: "COMPANY",
};

export const HOMEPAGE_CARDS = [
  {
    item: {
      img: cloudIcon,
      tag: "Secure cloud system",
      arabicTag: "نظام سحابي آمن",
    },
  },
  {
    item: {
      img: devicesIcon,
      tag: "Supports multiple stores",
      arabicTag: "يدعم الفروع المتعددة",
    },
  },
  {
    item: {
      img: noWifi,
      tag: "Works without internet",
      arabicTag: "يعمل بدون انترنت",
    },
  },
  {
    item: {
      img: analysis,
      tag: "Real-time reports and analysis",
      arabicTag: "تقارير وتحليلات لحظية",
    },
  },
  {
    item: {
      img: fingerPoint,
      tag: "User-friendly interfaces",
      arabicTag: " واجهات سهلة الاستخدام",
    },
  },
  {
    item: {
      img: reverseIcon,
      tag: "Continuous feature development",
      arabicTag: "تطوير مستمر للميزات",
    },
  },
  {
    item: {
      img: personSpeak,
      tag: "Advanced control of roles and permissions",
      arabicTag: "تحكم متطور للادوار والصلاحيات",
    },
  },
  {
    item: {
      img: callingIcon,
      tag: "Technical support around the clock",
      arabicTag: " دعم فني على مدار الساعة",
    },
  },
];
export const BSSINESS_CARDS = [
  {
    item: {
      img: Grocery,
      tag: "Grocery",
      arabicTag: "التموينات",
    },
  },
  {
    item: {
      img: restaurant,
      tag: "Restaurant",
      arabicTag: "المطاعم",
    },
  },
  {
    item: {
      img: cafe,
      tag: "Cafe",
      arabicTag: "المقاهي",
    },
  },
  {
    item: {
      img: Jewelery,
      tag: "Jewelery",
      arabicTag: "المجوهرات",
    },
  },
  {
    item: {
      img: clothes,
      tag: "Clothes & Retail",
      arabicTag: "الملابس و التجزئة",
    },
  },
  {
    item: {
      img: electronics,
      tag: "Electronics",
      arabicTag: "الإلكترونيات",
    },
  },
  {
    item: {
      img: Bussiness,
      tag: "Entrepreneur",
      arabicTag: "الأسر المنتجة",
    },
  },
  {
    item: {
      img: industrial,
      tag: "Industrial tools ",
      arabicTag: "الأدوات الصناعية والعدد",
    },
  },
  {
    item: {
      img: Mall,
      tag: "Other",
      arabicTag: "..أخرى",
    },
  },
];

export const INDUSTRIES = [
  "ACCOUNTING & INSURANCE",
  "AUTO PARTS SERVICES",
  "BUSINESS SERVICES ",
  "BEAUTY CARE",
  "Car maintenance centers",
  "CONSTRUCTION ENGINEERING BUILDING ",
  "DESIGNS CREATIVITY & PHOTOGRAPHY",
  "EDUCATION & TRAINING ",
  "FLIGHT & HOTEL RESERVATIONS ",
  "FURNITURE & FURNISHINGS ",
  "GOVERNMENT ",
  "HEALTH & TREATMENT",
  "LABOR & CLEANING SERVICES",
  "LAWYERS ",
  "Mobiles and electronic devices",
  "Maintenance of devices and equipment",
  "ONLINE STORE ",
  "SHOP & RETAILS",
  "TECHNICAL SERVICES ",
  "TRANSPORT TRAVEL & TOURISM ",
  "OTHER",
];

export const COUNTRIES = ["PAKISTAN", "SAUDI ARABIAN", "QATAR", "DUBAI", "AMERICAN"];

export const PROFESSIONS = ["Freelancer", "IT", "ENGINEER", "MARKETING ", "MANAGER", "DESIGN ", "LEGAL", "SALES", "ACCOUNTING", "OPERATING", "OTHER"];
export const CATAGORY = [""];

export const PAYMENT_TYPES = [{ name: "Card", active: true, default: true }];

export const INVOICE_TABLE_ATTRIBUTES = [
  { name: i18n("Form.DATE"), active: true },
  { name: i18n("INVOICES.TYPE"), active: true },
  { name: i18n("DASHBOARD.CUSTOMER"), active: true },
  { name: i18n("INVOICES.USER"), active: true },
  { name: i18n("Discount.STORE"), active: true },
  { name: i18n("INVOICES.AMOUNT"), active: true },
  { name: i18n("INVOICES.STATUS"), active: true },
];

export const DASHBOARD_ATTRIBUTES = [
  { name: i18n("DASHBOARD.TotalSales"), active: true, color: "#7925C7" },
  { name: i18n("DASHBOARD.Balance"), active: true, color: "#ED553B" },
  { name: i18n("DASHBOARD.Paid"), active: true, color: "#3CAEA3" },
  { name: i18n("DASHBOARD.Invoices"), active: true, color: "#F2994A" },
  { name: i18n("DASHBOARD.Customers"), active: true, color: "#25AFF3" },
];
export const PAYMENT_REFUND = ["Cash", "Card", "Online"];

export const CATEGORY_COLORS = [
  { color: "#E0E0E0", isChecked: false },
  { color: "#1F6198", isChecked: false },
  {
    color: "#AAC30C",
    isChecked: false,
  },
  {
    color: "#F062C0",
    isChecked: false,
  },
  { color: "#209B3B", isChecked: false },
  {
    color: "#62B4F0",
    isChecked: false,
  },
  {
    color: "#FFB822",
    isChecked: false,
  },
  {
    color: "#ED553B",
    isChecked: false,
  },
];

export const PRODUCT_COLORS_AND_SHAPES = [
  { color: "#E0E0E0", clipPath: "inset(0% 0% 0% 0%)" },
  { color: "#1F6198", clipPath: "circle(50% at 50% 50%)" },
  {
    color: "#AAC30C",
    clipPath: "polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)",
  },
  {
    color: "#F062C0",
    clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
  },
  {
    color: "#209B3B",
    clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%) ",
  },
  {
    color: "#62B4F0",
    clipPath: "polygon(50% 0%, 80% 10%, 100% 35%, 100% 70%, 80% 90%, 50% 100%, 20% 90%, 0% 70%, 0% 35%, 20% 10%)",
  },
  {
    color: "#FFB822",
    clipPath: "polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%)",
  },
  {
    color: "#ED553B",
    clipPath: "polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%)",
  },
];

export const INVOICE_DEFAULT_FILTER_STATE = {
  type: "",
  status: "",
  channel: "",
  store: "",
  product: "",
  user: "",
  startDate: "",
  endDate: "",
  typeName: "",
  statusName: "",
  channelName: "",
  storeName: "",
  productName: "",
  userName: "",
  startDateName: "",
  endDateName: "",
};

export const CURRENCIES = [
  "PKR",
  "SAR",
  "AED",
  "USD",
  "GBP",
  "AUD",
  "INR",
  "AFN",
  "ALL",
  "DZD",
  "AOA",
  "ARS",
  "AMD",
  "AWG",
  "AZN",
  "BSD",
  "BHD",
  "BDT",
  "BBD",
  "BYN",
  "BZD",
  "BMD",
  "BTN",
  "BOB",
  "BAM",
  "BWP",
  "BRL",
  "BND",
  "BGN",
  "BIF",
  "CVE",
  "KHR",
  "CAD",
  "KYD",
  "CLF",
  "CLP",
  "CNY",
  "COP",
  "COU",
  "KMF",
  "CDF",
  "CRC",
  "HRK",
  "CUC",
  "CUP",
  "CZK",
  "DJF",
  "DOP",
  "EGP",
  "SVC",
  "ERN",
  "ETB",
  "FKP",
  "FJD",
  "XAF",
  "GMD",
  "GEL",
  "GHS",
  "GIP",
  "DKK",
  "GTQ",
  "GNF",
  "GYD",
  "HTG",
  "HNL",
  "HKD",
  "HUF",
  "ISK",
  "NR",
  "IDR",
  "XDR",
  "IRR",
  "IQD",
  "ILS",
  "JJM",
  "JPY",
  "JOD",
  "KZT",
  "KES",
  "KPW",
  "KRW",
  "KWD",
  "KGS",
  "LAK",
  "LBP",
  "LSL",
  "LRD",
  "LYD",
  "MOP",
  "MGA",
  "MWK",
  "MYR",
  "MVR",
  "MRU",
  "MUR",
  "XUA",
  "MXN",
  "MXV",
  "MDL",
  "MNT",
  "MZN",
  "MMK",
  "NAD",
  "NPR",
  "NIO",
  "NGN",
  "OMR",
  "PAB",
  "PGK",
  "PYG",
  "PEN",
  "PHP",
  "PLN",
  "QAR",
  "MKD",
  "RON",
  "RUB",
  "RWF",
  "SHP",
  "XCD",
  "WST",
  "STN",
  "RSD",
  "SCR",
  "SLL",
  "SGD",
  "ANG",
  "XSU",
  "SBD",
  "SOS",
  "ZAR",
  "SSP",
  "EUR",
  "LKR",
  "SDG",
  "SRD",
  "NOK",
  "SZL",
  "SEK",
  "CHE",
  "CHF",
  "CHW",
  "SYP",
  "TWD",
  "TJS",
  "TZS",
  "THB",
  "XOF",
  "NZD",
  "TOP",
  "TTD",
  "TND",
  "TRY",
  "TMT",
  "UGX",
  "UAH",
  "USN",
  "UYI",
  "UYU",
  "UZS",
  "VUV",
  "VEF",
  "VND",
  "XPF",
  "MAD",
  "YER",
  "ZMW",
  "ZWL",
];

export const replacingObjectInArray = (orignalArray, arrayYouWantToAddedInOrignalArray) => {
  let result;
  result = arrayYouWantToAddedInOrignalArray.reduce(function(arr1, arr2) {
    let isMatchFound = false;
    arr1.forEach(function(list) {
      if (arr2._id === list._id) {
        list = Object.assign(list, arr2);
        isMatchFound = true;
      }
    });
    if (!isMatchFound) {
      arr1.push(arr2);
    }
    return arr1;
  }, orignalArray);
  if (result && result.length) {
    return result;
  }
};

export function shouldShowPricingPlanModalForTrial(subscriptionData, edit) {
  if (!edit) {
    const { currentPlan, userTrial, subscriptionInfo } = subscriptionData?.subscription || {};
    return (
      currentPlan?.plan === "Free" &&
      currentPlan?.status === "Running" &&
      userTrial?.isTrialStarted &&
      userTrial?.isTrialCancelled &&
      userTrial?.isTrialExpired &&
      !subscriptionInfo?.isSubscribed &&
      !subscriptionInfo?.isSubscribedExpired &&
      !subscriptionInfo?.isUnsubscribed
    );
  }
  return false;
}

export function shouldShowAddPaymentModal(subscriptionData, paymentCard) {
  const { currentPlan, userTrial, subscriptionInfo } = subscriptionData?.subscription || {};

  return (
    currentPlan?.plan === "Free" &&
    currentPlan?.status === "Running" &&
    userTrial?.isTrialStarted &&
    userTrial?.isTrialCancelled &&
    userTrial?.isTrialExpired &&
    !subscriptionInfo?.isSubscribed &&
    !subscriptionInfo?.isSubscribedExpired &&
    !subscriptionInfo?.isUnsubscribed &&
    !paymentCard
  );
}

export function shouldRedirectToAddUser(subscriptionData) {
  const { currentPlan, userTrial, subscriptionInfo } = subscriptionData?.subscription || {};

  return (
    currentPlan?.plan === "Free" &&
    currentPlan?.status === "Running" &&
    userTrial?.isTrialStarted &&
    userTrial?.isTrialCancelled &&
    userTrial?.isTrialExpired &&
    !subscriptionInfo?.isSubscribed &&
    !subscriptionInfo?.isSubscribedExpired &&
    !subscriptionInfo?.isUnsubscribed
  );
}

export function isFreePlanRunningAndTrialExpired(subscriptionData) {
  const currentPlan = subscriptionData?.subscription?.currentPlan;
  const userTrial = subscriptionData?.subscription?.userTrial;

  return (
    currentPlan?.plan === "Free" &&
    currentPlan?.status === "Running" &&
    userTrial?.isTrialStarted &&
    !userTrial?.isTrialCancelled &&
    userTrial?.isTrialExpired
  );
}

export const formatNumber = (number) => {
  return Number(number).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const shouldShowPricingPlanModal = (subscriptionData, edit) => {
  return (
    !edit &&
    subscriptionData?.subscription?.currentPlan?.plan === "Free" &&
    subscriptionData?.subscription?.currentPlan.status === "Running" &&
    subscriptionData?.subscription?.subscriptionInfo?.isUnsubscribed
  );
};

export const shouldShowTrialExpiredModal = (subscriptionData) => {
  return (
    subscriptionData?.subscription?.currentPlan.plan === "Free" &&
    subscriptionData?.subscription?.userTrial.isTrialExpired &&
    !subscriptionData?.subscription?.subscriptionInfo.isSubscribed &&
    !subscriptionData?.subscription?.subscriptionInfo.isUnsubscribed &&
    subscriptionData?.subscription.subscriptionEndedAt === undefined
  );
};

export const shouldShowPricingPlanModalAfterBackToFreePlan = (subscriptionData, edit) => {
  return (
    !edit &&
    subscriptionData?.subscription?.currentPlan?.plan === "Free" &&
    subscriptionData?.subscription?.currentPlan?.status === "Running" &&
    subscriptionData?.subscription?.userTrial?.isTrialStarted &&
    !subscriptionData?.subscription?.userTrial?.isTrialCancelled &&
    subscriptionData?.subscription?.userTrial?.isTrialExpired
  );
};

export const shouldShowPricingPlanModalConfirmAfterBackToFreePlan = (subscriptionData, edit) => {
  return (
    !edit &&
    subscriptionData?.subscription?.currentPlan?.plan === "Free" &&
    subscriptionData?.subscription?.currentPlan?.status === "Running" &&
    subscriptionData?.subscription?.userTrial?.isTrialStarted &&
    subscriptionData?.subscription?.userTrial?.isTrialCancelled &&
    subscriptionData?.subscription?.userTrial?.isTrialExpired
  );
};

export const homePagecategories = [
  { id: "cafes", label: "Cafes", arabicLabel: "مقاهي" },
  { id: "restaurants", label: "Restaurants", arabicLabel: "مطاعم" },
  { id: "grocery", label: "Grocery", arabicLabel: "تموينات" },
  { id: "electronics", label: "Electronics", arabicLabel: "إلكترونيات" },
  { id: "clothing_and_retail", label: "Clothing and Retail", arabicLabel: "ملابس و تجزئة" },
  { id: "jewelry", label: "Jewelry", arabicLabel: "مجوهرات" },
  { id: "product_families", label: "Product Families", arabicLabel: "أسر منتجة" },
  { id: "industrial_tools", label: "Industrial Tools", arabicLabel: "أدوات صناعية" },
  { id: "services", label: "Services", arabicLabel: "خدمات" },
  { id: "other", label: "Other..", arabicLabel: "أخرى.." },
];

export const homePageNavItems = [
  {
    id: "1",
    label: "Industries",
    content: homePagecategories,
  },
  {
    id: "2",
    label: "Prices",
    content: "",
  },
  {
    id: "3",
    label: "Help",
    content: "",
  },
  {
    id: "4",
    label: "Contact",
    content: "",
  },
  {
    id: "5",
    label: "language",
    content: "",
  },
  {
    id: "6",
    label: "Log in",
    content: "",
  },
];

export const homePageContentTabs = [
  { id: "tablet_based_pos", label: "POS Program", arabicLabel: "برنامج نقاط البيع " },
  { id: "product_management", label: "Product Management", arabicLabel: "إدارة المنتجات" },
  { id: "customer_management", label: "Customer Management", arabicLabel: "إدارة العملاء" },
  { id: "branch_management", label: "Stores Management", arabicLabel: "إدارة الفروع" },
  { id: "reports_and_analytics", label: "Reports & Analytics", arabicLabel: "تقارير وتحليلات" },
  { id: "more_features", label: "More ...", arabicLabel: "المزيد ..." },
];

export const HomePageContentCards = [
  {
    id: "tablet_based_pos",
    label: "Tablet-based Point of Sale (POS) System.",
    arabicLabel: "برنامج نقاط البيع عبر الأجهزة اللوحية",
    details: "A cloud-based app that turns your tablets into multiple points of sale, boosting operational efficiency across your branches.",
    arabicDetails: "تطبيق سحابي متكامل يتيح لك تحويل أجهزتك اللوحية إلى نقاط بيع متعددة بسهولة، مما يعزز كفاءة تشغيل فروعك.",
    img: tabletPos,
    arabicImg: tabletPosAr,
    points: [
      {
        label: "Easily issue and share your invoices with your customers.",
        arabicLabel: "أصدر وشارك فواتيرك بكل سهولة لعملائك",
      },
      {
        label: "Sell efficiently, online or offline.",
        arabicLabel: "أجري عمليات البيع بكفاءة سواء عبر الاتصال بالإنترنت أو بدونه (Online/Offline).",
      },
      {
        label: "Apply discounts and taxes during the sales process.",
        arabicLabel: "طَبّق الخصومات والضرائب أثناء عملية البيع.",
      },
      {
        label: "Create diverse payment methods.",
        arabicLabel: "أنشيْ طرق دفع متعددة لتلبية احتياجات عملائك.",
      },
      {
        label: "Easily invoice refund.",
        arabicLabel: "استرداد الفواتير بسهولة ومرونة.",
      },
      {
        label: "Customize the sales interface to suit your business style.",
        arabicLabel: "خصص واجهة البيع بما يتناسب مع طبيعة وأسلوب عملك.",
      },
    ],
  },
  {
    id: "product_management",
    label: "Smooth management of sales items.",
    arabicLabel: "إدارة سلسة لعناصر المبيعات",
    details: "Easily manage products, categories, and discounts, customize displays, add images, and control branch availability.",
    arabicDetails: "تحكّم بإدارة المنتجات والفئات والخصومات، خصص طريقة العرض، أضف صورًا ورموزًا للمنتجات، وحدد توافرها في الفروع.",
    img: saleManagement,
    arabicImg: saleManagementAr,
    points: [
      {
        label: "Create unlimited products.",
        arabicLabel: "أنشيء عدد غير محدود من المنتجات.",
      },
      {
        label: "Categorize products into categories to improve report accuracy.",
        arabicLabel: "صنّف المنتجات ضمن فئات لتحسين دقة التقارير.",
      },
      {
        label: "Track products by SKU and barcode.",
        arabicLabel: "تتبع المنتجات باستخدام رقم SKU والباركود.",
      },
      {
        label: "Allow pricing during sales based on permissions.",
        arabicLabel: "امكانية تحديد السعر المنتج أثناء البيع حسب الصلاحيات الممنوحة.",
      },
      {
        label: "Control product availability across one or all stores.",
        arabicLabel: "إدارة إتاحة المنتجات أو تعطيلها على مستوى متجر واحد أو جميع المتاجر.",
      },
    ],
  },
  {
    id: "customer_management",
    label: "Get to know your customers better.",
    arabicLabel: "إعرف عملائك أكثر",
    details: "Understand your customers, track their preferences and feedback, and help turn new shoppers into loyal customers.",
    arabicDetails:
      "تعرف على عملائك، حدّد تفضيلاتهم وتتبع ملاحظاتهم، ووفّر للبائعين إمكانية الاطلاع على سجل العملاء لتحويل المتسوقين الجدد إلى عملاء دائمين.",
    img: knowCustomers,
    arabicImg: knowCustomersAr,
    points: [
      {
        label: "Build a comprehensive customer database.",
        arabicLabel: "إنشاء قاعدة بيانات متكاملة لعملائك.",
      },
      {
        label: "Record each customer's preferences.",
        arabicLabel: "تسجيل تفضيلات كل عميل.",
      },
      {
        label: "View customer visit history to offer personalized service.",
        arabicLabel: "استعراض سجل زيارات العميل لتقديم خدمة مخصصة.",
      },
      {
        label: "Loyalty program to encourage repeat purchases (Coming soon...).",
        arabicLabel: "برنامج نقاط ولاء لتحفيز تكرار الشراء ومكافأة العملاء (قريبًا...).",
      },
    ],
  },
  {
    id: "branch_management",
    label: "Branch Management.",
    arabicLabel: "إدارة الفروع",
    details: "We support your business growth by enabling you to easily add branches and free points of sale with a single click.",
    arabicDetails: "ندعم نمو أعمالك وتمكينك من التوسع بسهولة عبر إضافة فروع ونقاط بيع مجانية بلمسة زر.",
    img: branchManagement,
    arabicImg: branchManagementAr,
    points: [
      {
        label: "Add unlimited branches and points of sale for free.",
        arabicLabel: "أضف عدد غير محدود من الفروع ونقاط البيع مجانًا.",
      },
      {
        label: "Expand your business by adding branches and points of sale as needed.",
        arabicLabel: "وسّع أعمالك بإضافة فروع ونقاط بيع حسب احتياجاتك.",
      },
      {
        label: "Link POS devices to your branches through a unified account.",
        arabicLabel: "ربط نقاط البيع تلقائيًا بفروعك من خلال حساب موحد.",
      },
      {
        label: "Enable users to access a single or multiple POS locations using a PIN.",
        arabicLabel: "تمكين المستخدمين من الدخول إلى نقطة بيع لفرع/فروع متعددة عبر رمز PIN.",
      },
    ],
  },
  {
    id: "reports_and_analytics",
    label: "Comprehensive reports and analytics.",
    arabicLabel: "تحليلات وتقارير شاملة",
    details: "Stay constantly informed with unified reports and analytics for your business, anytime and anywhere.",
    arabicDetails: "ابقَ على اطلاع دائم بالتقارير والتحليلات الموحدة لأعمالك التجارية، من أي مكان وفي أي وقت.",
    img: reportAnalytics,
    arabicImg: reportAnalyticsAr,
    points: [
      {
        label: "View top-selling products by quantity or value with percentages.",
        arabicLabel: "عرض المنتجات الأعلى مبيعًا حسب الكمية أو القيمة مع النسبة المئوية.",
      },
      {
        label: "Analyze sales by branch, user, or account.",
        arabicLabel: "تحليل الإيرادات ومتوسط المبيعات حسب الفرع/الموظف/الحساب الموحد.",
      },
      {
        label: "Display revenue and customer trends with timeline charts.",
        arabicLabel: "استعراض الرسوم البيانية الزمنية للإيرادات والعملاء.",
      },
      {
        label: "View detailed reports on payment types, discounts, and taxes.",
        arabicLabel: "عرض تقارير تفصيلية لطرق الدفع، والخصومات، والضرائب والمعدلات.",
      },
      {
        label: "Easily export sales data.",
        arabicLabel: "تصدير بيانات المبيعات",
      },
    ],
  },
  {
    id: "more_features",
    label: "More features...",
    arabicLabel: "المزيد من الميزات ...",
    img: moreFeatures,
    arabicImg: moreFeaturesAr,
    points: [
      {
        label: "Send receipts to your customers via email and SMS.",
        arabicLabel: "أرسل الإيصالات لعملائك عبر البريد الإلكتروني والرسائل القصيرة.",
      },
      {
        label: "Customize your branding on receipts for a professional image.",
        arabicLabel: "قدّم صورة احترافية لعملائك بتخصيص علامتك التجارية في الإيصالات.",
      },
      {
        label: "Apply discounts during the sales process.",
        arabicLabel: "تطبيق الخصومات أثناء البيع",
      },
      {
        label: "Compliant with the Zakat, Tax, and Customs Authority system.",
        arabicLabel: "متوافق مع نظام هيئة الزكاة والضريبة والجمارك",
      },
    ],
  },
];

export const TABLET_BASED_POS_CARDS = [
  {
    id: "1",
    points: [
      {
        label: "Simple and fast user interface to achieve smooth selling with one click.",
        arabicLabel: "واجهة استخدام بسيطة وسريعة لتحقيق بيع سلس بضغطة واحدة.",
      },
      {
        label:
          "Display the product in its image and name or in a distinctive color with an immediate addition to the ticket by scanning the barcode or pressing.",
        arabicLabel: "عرض المنتج بصورته واسمه أو بلون مميز مع إضافة فورية الى التذكرة بمسح الباركود أو الضغط.",
      },
      {
        label: "Modifying the price and adding new products during the sale according to the user's permissions.",
        arabicLabel: "تعديل السعر وإضافة منتجات جديدة أثناء البيع وفق صلاحيات المستخدم.",
      },
    ],
    img: tabletImage,
    icon: tabletIcon,
  },
  {
    id: "2",
    points: [
      {
        label: "Instant uninterrupted sale even if internet is lost",
        arabicLabel: "بيع فوري دون انقطاع حتى في حالة فقدان الإنترنت",
      },
      {
        label: "Save your invoices and sales locally instantly to ensure data loss",
        arabicLabel: "حفظ فواتيرك ومبيعاتك محلياً فورياً لضمان عدم فقدان البيانات",
      },
      {
        label: "Automatically intelligent data synchronization when connection is restored",
        arabicLabel: "مزامنة ذكية للبيانات تلقائياً عند استعادة الاتصال",
      },
    ],
    img: salesImg,
    icon: noWifiIcon,
  },
  {
    id: "3",
    points: [
      {
        label: "Issuing tax invoices or refund invoices with the ability to print them locally or send them electronically.",
        arabicLabel: "إصدار الفواتير الضريبية أو فواتير الاسترداد مع إمكانية طباعتها محليًا أو إرسالها إلكترونيًا.",
      },
      {
        label: "Easily customize the invoice, including your business name and brand.",
        arabicLabel: "تخصيص الفاتورة بسهولة تامة، بما في ذلك اسم النشاط التجاري والعلامة التجارية.",
      },
      {
        label: "Comprehensive support for discounts and taxes, with a clear display of the tax value within the invoice.",
        arabicLabel: "دعم شامل للخصومات والضرائب، مع عرض واضح لقيمة الضريبة داخل الفاتورة.",
      },
    ],
    img: viewInvoiceImg,
    icon: tabletIcon,
  },
  {
    id: "4",
    points: [
      {
        label: "Apply discounts by percentage or a fixed amount according to the available powers.",
        arabicLabel: "تطبيق خصومات بنسبة مئوية أو بمبلغ ثابت حسب الصلاحيات المتاحة.",
      },
      {
        label: "Choose to apply the discount to a single product or to the entire invoice.",
        arabicLabel: "اختيار تطبيق الخصم على منتج واحد أو على كامل الفاتورة.",
      },
      {
        label: "Take advantage of all discounts available to the user according to his powers.",
        arabicLabel: "الاستفادة من جميع الخصومات المتاحة للمستخدم وفق صلاحياته.",
      },
    ],
    img: applyDiscountImg,
    icon: tabletIcon,
  },
  {
    id: "5",
    points: [
      {
        label: "Choose the appropriate payment method for customers according to the payment channels available in the facility.",
        arabicLabel: "اختر طريقة الدفع المناسبة للعملاء حسب قنوات الدفع المتاحة في المنشأة.",
      },
      {
        label: "Reduce cash payment errors with quick and easy rounding buttons.",
        arabicLabel: "قلّل أخطاء الدفع النقدي باستخدام أزرار تقريب المبالغ بسرعة وسهولة.",
      },
      {
        label: "Break down the invoice into partial payments and print separate receipts for your willing customers.",
        arabicLabel: "قسّم الفاتورة إلى مدفوعات جزئية واطبع إيصالات مستقلة لعملائك الراغبين.",
      },
    ],
    img: paymentsImg,
    icon: paymentIocn,
  },
  {
    id: "6",
    points: [
      {
        label: "Browse and view invoices based on your permissions.",
        arabicLabel: "تصفح واستعرض الفواتير بناءً على الصلاحيات الممنوحة لك.",
      },
      {
        label: "Easily carry out bill refunds with flexible and straightforward options.",
        arabicLabel: "نفّذ عمليات استرداد الفواتير بسهولة عبر خيارات مرنة ومباشرة.",
      },
      {
        label: "Reprint invoices or send them by email or text to customers.",
        arabicLabel: "أعد طباعة الفواتير أو أرسلها بالبريد الإلكتروني أو الرسائل النصية للعملاء.",
      },
    ],
    img: viewInvoicesImg,
    icon: menuDisplayIcon,
  },
  {
    id: "7",
    points: [
      {
        label: "Choose how products and services are displayed in a grid or mini-menu as needed.",
        arabicLabel: "اختر طريقة عرض المنتجات والخدمات بشكل شبكة أو قائمة مصغرة حسب الحاجة.",
      },
      {
        label: "Easily access products by flexibly organizing the display with enlarged or thumbnail images.",
        arabicLabel: "سهّل الوصول للمنتجات عبر تنظيم العرض بصور مكبرة أو مصغرة بمرونة.",
      },
      {
        label: "Add additional custom sales pages to speed up your daily selling tasks.",
        arabicLabel: "أضف صفحات بيع إضافية مخصصة لتسريع أداء مهام البيع اليومية.",
      },
    ],
    img: productDisplayImg,
    icon: computerIcon,
  },
  {
    id: "8",
    points: [
      {
        label: "Secure access to the application using a special PIN code for each user.",
        arabicLabel: "دخول آمن للتطبيق باستخدام رمز PIN خاص لكل مستخدم.",
      },
      {
        label: "Automatically lock screen to protect data when the device is left unattended.",
        arabicLabel: "قفل الشاشة تلقائيًا لحماية البيانات عند ترك الجهاز دون مراقبة.",
      },
      {
        label: "Fast switching between users by entering a PIN code easily.",
        arabicLabel: "التبديل السريع بين المستخدمين عبر إدخال رمز PIN بسهولة.",
      },
    ],
    img: pinCodeDisplayImg,
    icon: pinCodeIcon,
  },
];
export const PRODUCT_MANAGEMENT_CARDS = [
  {
    id: "1",
    points: [
      {
        label: "Easily add products with image or color representation, along with barcode number and SKU for easy identification.",
        arabicLabel: "إضافة المنتجات بسهولة مع إدخال الصورة أو اللون، ورقم الباركود وSKU لتسهيل التعرف.",
      },
      {
        label: "Choose the selling method (by piece or by weight), with the option to set the price in advance or during the sale.",
        arabicLabel: "اختيار طريقة البيع بالقطعة أو الوزن، مع إمكانية تحديد السعر مسبقًا أو أثناء عملية البيع.",
      },
      {
        label: "Enable or disable taxes as needed, with an interactive preview of the product's icon or image on the point of sale.",
        arabicLabel: "تفعيل أو تعطيل الضرائب حسب الحاجة، مع معاينة تفاعلية لرمز أو صورة المنتج على نقطة البيع.",
      },
    ],
    img: productSettingsImg,
    icon: productSettingsIcon,
  },
  {
    id: "2",
    points: [
      {
        label: "Create categories and customize their colors to simplify the organization of the point-of-sale interface.",

        arabicLabel: "إنشاء الفئات وتخصيص ألوانها لتسهيل تنظيم واجهة نقاط البيع.",
      },
      {
        label: "Easily manage categories by editing their names or deleting them when needed.",
        arabicLabel: "إدارة الفئات بسهولة من خلال تعديل اسمها أو حذفها عند الحاجة.",
      },
      {
        label: "Link products to each category with a single click to organize sales and enhance the user experience.",
        arabicLabel: "ربط المنتجات بكل فئة بضغطة زر، لتنظيم البيع وتحسين تجربة المستخدم.",
      },
    ],
    img: createCategoryImg,
    icon: createCategoryIcon,
  },
  {
    id: "3",
    points: [
      {
        label: "Create discounts based on a fixed amount or percentage, and apply them according to user permissions.",
        arabicLabel: "إنشاء خصومات محددة بالقيمة أو النسبة، وتطبيقها حسب صلاحيات المستخدم.",
      },
      {
        label: "Flexibility to adjust the discount value during the sale, based on the user's assigned role.",
        arabicLabel: "مرونة في التحكم بسعر الخصم أثناء البيع، حسب الدور الممنوح للمستخدم.",
      },
      {
        label: "Ability to create restricted discounts that can only be used by supervisors or authorized personnel.",
        arabicLabel: "إمكانية إنشاء خصومات مقيدة لا تُستخدم إلا من قبل المشرفين أو المصرّح لهم.",
      },
    ],
    img: applyDiscountsImg,
    icon: applyDiscountIcon,
  },
  {
    id: "4",
    points: [
      {
        label: "Full control over products, categories, and discounts with precise user permissions.",
        arabicLabel: "تحكّم كامل في المنتجات والفئات والخصومات مع صلاحيات دقيقة للمستخدمين.",
      },
      {
        label: "Easily delete one or multiple items from the list in a single step.",
        arabicLabel: "حذف عنصر واحد أو عدة عناصر بسهولة من القائمة في خطوة واحدة.",
      },
      {
        label: "Smooth interface that allows you to browse, edit, or organize content efficiently.",
        arabicLabel: "واجهة سلسة تمكّنك من تصفح، تعديل، أو تنظيم المحتوى بكفاءة.",
      },
    ],
    img: fullControlImg,
    icon: tickIcon,
    showTwoIcons: true,
  },
];
export const BRANCH_MANAGEMENT_CARDS = [
  {
    id: "1",
    points: [
      {
        label: "Customize the invoice based on each branch's identity to meet customer needs.",
        arabicLabel: "تخصيص الفاتورة حسب الهوية الخاصة بكل فرع لتلبية احتياجات العميل.",
      },
      {
        label: "Enable or disable specific features according to branch preferences for easy control.",
        arabicLabel: "تفعيل أو تعطيل بعض الميزات حسب تفضيلات الفرع لسهولة التحكم.",
      },
      {
        label: "Customize the product display layout on the sales page to suit the workflow.",
        arabicLabel: "تخصيص طريقة عرض المنتجات في صفحة البيع لتناسب أسلوب العمل.",
      },
    ],
    img: branchFirstImg,
    icon: branchIcon,
  },
  {
    id: "2",
    points: [
      {
        label: "Easy scalability with a multi-outlet system to meet various business needs.",

        arabicLabel: "سهولة التوسع بنظام متعدد المنافذ لتلبية احتياجات الأعمال المختلفة.",
      },
      {
        label: "Analyze sales data to identify demand patterns and support better decision-making.",
        arabicLabel: "تحليل بيانات المبيعات لتحديد أنماط الطلب والمساعدة في اتخاذ قرارات أفضل.",
      },
      {
        label: "Start with a single store and easily expand to multiple branches or points of sale.",
        arabicLabel: "القدرة على البدء بمتجر واحد ثم التوسع إلى عدة فروع أو نقاط بيع بكل سهولة.",
      },
    ],
    icon: branchIcon,
    img: branchSecondImg,
    isTripleIcon: true,
  },
];
export const REPORTS_AND_ANALYTICS_CARDS = [
  {
    id: "1",
    points: [
      {
        label: "Track sales trends and react quickly to changes to improve performance.",
        arabicLabel: "تتبع اتجاهات المبيعات والتفاعل بسرعة مع التغيرات لتحسين الأداء.",
      },
      {
        label: "Easily view full sales history and transaction details to support decision-making.",
        arabicLabel: "عرض سجل المبيعات الكامل وتفاصيل المعاملات بسهولة لدعم اتخاذ القرار.",
      },
      {
        label: "Export sales data to spreadsheets to facilitate data analytics and review.",
        arabicLabel: "تصدير بيانات المبيعات إلى جداول البيانات لتسهيل تحليلات البيانات ومراجعتها.",
      },
    ],
    img: trackSalesImg,
    icon: trackSalesIcon,
  },
  {
    id: "2",
    points: [
      {
        label: "Provides various sales reports by time and date to ensure a comprehensive understanding of performance.",

        arabicLabel: "توفر تقارير مبيعات متنوعة حسب الوقت والتاريخ لضمان فهم شامل للأداء.",
      },
      {
        label: "Classify reports by branch, payment method, and category to customize the analysis.",
        arabicLabel: "تصنيف التقارير حسب الفرع، طريقة الدفع والفئة لتخصيص التحليل.",
      },
      {
        label: "The ability to export reports related to deductions and taxes for accurate review.",
        arabicLabel: "إمكانية تصدير التقارير التي تتعلق بالخصومات والضرائب لمراجعة دقيقة.",
      },
    ],
    icon: saleReportsIcon,
    img: salesReportsImg,
  },
  {
    id: "3",
    points: [
      {
        label: "It provides a comprehensive view of all invoices, sales and refunds for easy follow-up.",
        arabicLabel: "توفر رؤية شاملة لجميع الفواتير والمبيعات والمستردات لسهولة المتابعة.",
      },
      {
        label: "Quickly re-share invoices to facilitate repetitive actions.",
        arabicLabel: "إعادة مشاركة الفواتير بسرعة لتسهيل الإجراءات المتكررة.",
      },
      {
        label: "Easily filter data for quick access to accurate decisions.",
        arabicLabel: "فلترة البيانات بسهولة للوصول السريع إلى قرارات دقيقة.",
      },
    ],
    icon: invoiceIcon,
    img: viewOfInvoicesImg,
  },
];

export const HELP_TOPICS = [
  {
    name: "Registration & Login",
    arabicName: "التسجيل والدخول",
    link: "Registration & Login",
    isActive: true,
  },
  {
    name: "Items",
    arabicName: "العناصر",
    link: "items",
    isActive: false,
  },
  {
    name: "Sale",
    arabicName: "البيع",
    link: "sale",
    isActive: false,
  },
  {
    name: "Invoices",
    arabicName: "الفواتير",
    link: "invoices",
    isActive: false,
  },
  {
    name: "Customer",
    arabicName: "العملاء",
    link: "customer",
    isActive: false,
  },
  {
    name: "Reports",
    arabicName: "التقارير",
    link: "reports",
    isActive: false,
  },
  {
    name: "Company",
    arabicName: "الشركة",
    link: "company",
    isActive: false,
  },
  {
    name: "Settings",
    arabicName: "الاعدادت",
    link: "settings",
    isActive: false,
  },
];

export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.fatoraty.pos";

export const socialLinks = {
  tiktok: "https://www.tiktok.com/@fatoraty.pos",
  youtube: "https://www.youtube.com/@fatoratypos",
  snapchat: "https://www.snapchat.com/add/fatoraty",
  x: "https://x.com/fatoraty",
  instagram: "https://www.instagram.com/fatoraty/",
  facebook: "https://www.facebook.com/fatoraty/",
};
